<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch" :default_values="defaultParams">
      <template>
        <el-button type="primary" @click="handleExport">导出</el-button>
        <el-button type="primary" @click="processedOtaUpgrade">OTA升级</el-button>
      </template>
    </com-search>
    <com-card class="mt-15px">
      <com-table
        class="mt-15px"
        :columns="columns"
        :api="api"
        ref="table"
        :defaultParams="defaultParams"
      >
        <template #deviceStatus="row">
          {{ row.data.deviceStatus === 2 ? '离线' : row.data.deviceStatus === 1 ? '在线' : '' }}
        </template>
        <template #bindStatus="row">
          {{ row.data.bindStatus === 0 ? '未绑定' : row.data.bindStatus === 1 ? '已绑定' : '' }}
        </template>
        <template #bindTime="row">
          <div v-if="row.data.bindTime">
            {{ row.data.bindTime | formatDate }}
          </div>
        </template>
      </com-table>
    </com-card>
  </com-page>
</template>

<script>
import { equListApi, otaUpgradeApi } from '@/api/equ'
import utils from 'my-tools-library'
import { formatDate } from '@/filters'
import { exportExcel } from '@/utils/index'

export default {
  data() {
    return {
      api: equListApi,
      defaultParams: {},
      searchColumns: [
        {
          label: '设备号',
          type: 'input',
          prop: 'sn'
        },
        {
          label: '二维码',
          type: 'input',
          prop: 'label'
        },
        {
          label: '生产批次',
          type: 'input',
          prop: 'batchName'
        },
        {
          label: '绑定网点',
          type: 'input',
          prop: 'storeName'
        },
        {
          label: '在线状态',
          type: 'select',
          prop: 'deviceStatus',
          option: [
            {
              label: '在线',
              value: 1
            },
            {
              label: '离线',
              value: 2
            }
          ]
        },
        {
          label: '绑定状态',
          type: 'select',
          prop: 'bindStatus',
          option: [
            {
              label: '已绑定',
              value: 1
            },
            {
              label: '未绑定',
              value: 0
            }
          ]
        },
        {
          label: '绑定时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '编号',
          prop: 'number',
          width: '150'
        },
        {
          label: '设备号',
          prop: 'sn',
          width: '200'
        },
        {
          label: '二维码',
          prop: 'label',
          width: '170'
        },
        {
          label: 'ICCID',
          prop: 'iccid',
          width: 200
        },
        {
          label: '二维码链接',
          prop: 'labelUrl',
          width: 500
        },
        {
          label: '生产批次',
          prop: 'batchName',
          width: '150'
        },
        {
          label: '在线状态',
          prop: 'deviceStatus',
          type: 'slot',
          slotName: 'deviceStatus',
          width: '100'
        },
        {
          label: '绑定网点',
          prop: 'storeName',
          auto: true
        },
        {
          label: '绑定状态',
          prop: 'bindStatus',
          type: 'slot',
          slotName: 'bindStatus',
          width: '100'
        },
        {
          label: '绑定时间',
          prop: 'bindTime',
          type: 'slot',
          slotName: 'bindTime',
          width: '150'
        },
        {
          label: '绑定人',
          prop: 'nickname',
          width: '100'
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      }
    }
  },
  methods: {
    handleSearch(val) {
      console.log('val :>> ', val)
      if (utils.isEmptyObj(val)) {
        this.defaultParams.batchName = ''
      }
      this.exportQuery = {
        pageIndex: 1,
        pageSize: 10000,
        ...val
      }
      const params = { ...val }
      if (params.beginTime) {
        params.startTime = val.beginTime
        delete params.beginTime
      }
      this.$refs.table.search(params)
    },
    handleExport() {
      this.$message.info('请稍等,正在导出...')
      equListApi(this.exportQuery).then((res) => {
        const { records } = res.data
        // eslint-disable-next-line prefer-const
        let newArr = []
        records.forEach((item) => {
          const params = {
            编号: item.number,
            设备号: item.sn,
            二维码内容: item.labelUrl,
            二维码序列号: item.label,
            生产批次: item.batchName,
            在线状态:
              // eslint-disable-next-line no-nested-ternary
              item.deviceStatus === 0 ? '离线' : item.deviceStatus === 1 ? '在线' : '不存在',
            绑定网点: item.storeName,

            绑定状态:
              // eslint-disable-next-line no-nested-ternary
              item.bindStatus === 0 ? '未绑定' : item.bindStatus === 1 ? '已绑定' : '不存在',
            绑定时间: item.bindTime ? formatDate(item.bindTime) : '',
            绑定人: item.bindUser
          }
          newArr.push(params)
        })
        exportExcel(newArr, '设备列表')
      })
    },
    processedOtaUpgrade() {
      this.$confirm('确定要让设备查询OTA升级吗? 若有新版本设备将启动更新程序', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        async () => {
          await otaUpgradeApi()
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        },
        () => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        }
      )
    }
  },
  created() {
    const { name } = this.$route.params
    if (name) {
      this.defaultParams.batchName = name
      this.exportQuery.batchName = name
    }

    console.log('rou :>> ', this.$route)
  }
}
</script>
